import { useSystemDevice } from '../../hooks/useSystemDevice';
import './SideHeaderText.scss';

function SideHeaderText({
  top,
  heading,
  bottom,
}: {
  top?: string;
  heading?: string;
  bottom?: string;
}) {
  const scope = 'SideHeaderText';
  const systemDevice = useSystemDevice();

  const className = [scope, `${scope}--${systemDevice}`].join(' ');

  return (
    <div className={className}>
      <div className={scope + '-top'}>{top}</div>
      <h1 className={scope + '-heading'}>{heading}</h1>
      <div className={scope + '-bottom'}>{bottom}</div>
    </div>
  );
}

export default SideHeaderText;
